import React from 'react';

import { notEmpty, mapIndexed } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const ProjectApprovals = ({ approvals }) => notEmpty(approvals) ? (
    <div>
        <DefinitionHeader translate="project.work.approval" iconType="check-circle" />
        <div className="panel-view">
            <ul>
                { mapIndexed((approval, index) => (
                    <li key={index}>
                        {approval.text}
                    </li>
                ), approvals)}
            </ul>
        </div>
    </div>
) : null;

export default ProjectApprovals;
